import { memo } from 'react';
import PropTypes from 'prop-types';

import Cta from '../cta';
import ImageDisplay from '../imageDisplay';

const _LandingBanner = ({ image, title, eyebrow, description, cta }) => {
	const hasImage = Boolean(image?.gatsbyImageData || image?.file);

	return (
		<div
			className={`section landing-banner ${
				!hasImage ? 'landing-banner--no-image' : ''
			}`}
		>
			<div className="section__content landing-banner__content">
				<figure className="landing-banner__image">
					<ImageDisplay
						className="landing-banner__image-svg"
						alt={image?.description}
						image={image?.gatsbyImageData}
						src={image?.file?.url}
					/>
				</figure>
				<div className="landing-banner__body">
					<p className="typography typography--overline typography--grayscale-60">
						{eyebrow}
					</p>
					<h1 className="typography typography--h1 typography--secondary">
						{title}
					</h1>
					<hr className="hr hr--gradient-orange" />
					<p className="typography typography--body-big landing-banner__text">
						{description?.description}
					</p>
					<Cta {...cta} />
				</div>
			</div>
		</div>
	);
};

_LandingBanner.propTypes = {
	image: PropTypes.shape({
		gatsbyImageData: PropTypes.object,
		description: PropTypes.string,
		file: PropTypes.object,
	}),
	description: PropTypes.shape({
		description: PropTypes.string,
	}),
	title: PropTypes.node.isRequired,
	eyebrow: PropTypes.string,
	cta: PropTypes.oneOfType([
		PropTypes.shape({
			title: PropTypes.string,
			link: PropTypes.string,
		}),
		PropTypes.shape({
			title: PropTypes.string,
			selector: PropTypes.string,
		}),
	]),
	ctaEvent: PropTypes.func,
};

_LandingBanner.defaultProps = {
	style: '',
	image: null,
	cta: null,
};

const LandingBanner = memo(_LandingBanner);

export default LandingBanner;
